import { render, staticRenderFns } from "./SelectedItem.vue?vue&type=template&id=71153700&scoped=true"
import script from "./SelectedItem.vue?vue&type=script&lang=js"
export * from "./SelectedItem.vue?vue&type=script&lang=js"
import style0 from "./SelectedItem.vue?vue&type=style&index=0&id=71153700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71153700",
  null
  
)

export default component.exports